// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__rNxNT","title":"AfterBackImages_title__2ZGXd","images":"AfterBackImages_images__2tkOb"};